import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取用户信息
 */
export const userInfo = (params: {}) => postWithJson(`/roc/info.np`, params)

/**
 * 登出系统
 */
export const logout = (params = {}) => {
    return postWithJson('/roc/logout.np', params)
}
